import React, {useEffect, useState} from "react";
import {BusinnesWrap} from "components/atoms/BusinessSetup/BusinessSetup.styles";
import Heading from "components/atoms/Auth/Heading";
import Form from "components/molecules/Form/Form";
import Field from "components/molecules/Field";
import {useForm} from "components/molecules/Form";
import {Autocomplete} from "@react-google-maps/api";
import Button from "components/molecules/Button";
import CenterModal from "components/molecules/Modal/CenterModal";
import AddressModal from "../AddressModal";
import {useDispatch} from "react-redux";
import {useSelector} from "react-redux";
import {setBusinessSetup2} from "store/reducers/businessSlice";

const BusinessMap = ({setFormData, setCurrentStep, currentStep, totalSteps, prevData, logo, cuisine_data}) => {
    const [form] = useForm();
    const [address, setAddress] = useState({
        street_address: "",
        city: "",
        state: "",
        country: "",
        postal_code: "",
        latlng: {
            lat: null,
            lng: null,
        },
    });
    const [addressModal, setAddressModal] = useState(false);
    const [searchValue, setSearchValue] = useState("");
    const dispatch = useDispatch();
    const {businessSetup2} = useSelector(state => state.business);
    // useEffect(() => {
    //     if (Object.keys(prevData).length > 0 && currentStep === 1) {
    //         form.setFieldsValue({
    //             address: prevData?.address,
    //             state: prevData?.state,
    //             city: prevData?.city,
    //             postal_code: prevData?.postal_code,
    //             area: prevData?.address,
    //         });
    //         setAddress(prevData?.address);
    //     }
    // }, [prevData, currentStep, form]);

    // useEffect(() => {
    //     if (searchValue) {
    //         setAddress(prev => ({
    //             ...prev,
    //             street_address: searchValue,
    //         }));
    //     }
    // }, [searchValue]);

    const handlePlaceSelect = place => {
        if (place.geometry && place.geometry.location) {
            // Helper function to extract specific values
            const getAddressComponent = type => {
                const component = place.address_components.find(comp => comp.types.includes(type));
                return component ? component.long_name : "";
            };

            setAddress({
                street_address: place.formatted_address || "",
                city: getAddressComponent("locality"),
                state: getAddressComponent("administrative_area_level_1"),
                country: getAddressComponent("country"),
                postal_code: getAddressComponent("postal_code"),
                latlng: {
                    // changed from latLang to latlng
                    lat: place.geometry.location.lat(),
                    lng: place.geometry.location.lng(),
                },
            });
        }
    };

    const AddressModalOpen = () => {
        setAddressModal(true);
    };
    function handleSubmit(e) {
        const values = form.getFieldsValue();
        // Merge manually entered fields into address
        // console.log(values, "values");
        const updatedAddress = {
            // ...address,
            street_address: address.street_address || "",
            // suiteNumber: values.suiteNumber || "",
            city: values.city || "",
            state: values.province || "",
            postal_code: values.postal_code || "",
            area: values.area || "",
            latlng: {
                lat: address.latlng?.lat || 51.0447, // Default to Calgary, Alberta if no coordinates
                lng: address.latlng?.lng || -114.0719,
            },
        };

        // Ensure all address fields have at least empty string values
        Object.keys(updatedAddress).forEach(key => {
            if (updatedAddress[key] === undefined || updatedAddress[key] === null) {
                if (key === "latlng") {
                    // Make sure latlng has valid values
                    updatedAddress.latlng = {
                        lat: updatedAddress.latlng?.lat || 51.0447,
                        lng: updatedAddress.latlng?.lng || -114.0719,
                    };
                } else {
                    updatedAddress[key] = "";
                }
            }
        });
        // Validate all required fields
        // const isInvalid =
        //     !updatedAddress.street_address ||
        //     !updatedAddress.city ||
        //     !updatedAddress.state ||
        //     !updatedAddress.postal_code ||
        //     updatedAddress.latlng.lat == null ||
        //     updatedAddress.latlng.lng == null;

        // if (isInvalid) {
        //     alert("Please fill in all required address fields and select a valid location on the map.");
        //     return;
        // }
        // console.log(updatedAddress.street_address.formatted_address, " updatedAddress.street_address");
        const stepTwo = {
            address: updatedAddress,
            state: updatedAddress.state,
            city: updatedAddress.city,
            postal_code: updatedAddress.postal_code,
            area: e.area || "",
            // suiteNumber: e.suiteNumber || "",
        };
        dispatch(setBusinessSetup2(stepTwo));

        setFormData(prev => ({
            ...prev,
            step2: stepTwo,
        }));
        setCurrentStep(3);
    }

    useEffect(() => {
        if (businessSetup2 && Object.keys(businessSetup2).length > 0) {
            setSearchValue(businessSetup2?.address?.street_address);
            form.setFieldsValue({
                province: businessSetup2?.address?.state,
                city: businessSetup2?.address?.city,
                postal_code: businessSetup2?.address?.postal_code,
                area: businessSetup2?.address?.area,
                suiteNumber: businessSetup2?.address?.suiteNumber,
            });
            setAddress(businessSetup2?.address);
        }
    }, [businessSetup2, form]);

    useEffect(() => {
        if (address && Object.keys(address).length > 0) {
            form.setFieldsValue({
                province: address?.state,
                city: address?.city,
                postal_code: address?.postal_code,
                area: address?.area,
                suiteNumber: address?.suiteNumber,
            });
        }
    }, [address, form, address?.state]);

    useEffect(() => {
        if (searchValue) {
            setAddress(prev => ({
                ...prev,
            }));
        }
    }, [searchValue]);

    return (
        <>
            <CenterModal
                title="Select Location"
                open={addressModal}
                setOpen={setAddressModal}
                width="994"
                parentClass="location-modalWrap">
                <AddressModal
                    inputValue={searchValue?.formatted_address}
                    setInputValue={setSearchValue}
                    handlePlaceSelect={handlePlaceSelect}
                    closeModal={() => setAddressModal(false)}
                />
            </CenterModal>

            <BusinnesWrap $padding={searchValue}>
                <Heading
                    heading="Provide"
                    ColoredText="Business Location!"
                    para="Customers & Riders will use this information to find your store."
                />
                <Form form={form} onSubmit={handleSubmit}>
                    {/* <Autocomplete
                        onLoad={autocomplete =>
                            autocomplete.addListener("place_changed", () => handlePlaceSelect(autocomplete.getPlace()))
                        }
                        options={{componentRestrictions: {country: "CA"}}}> */}
                    <div className="input map-input locate-input" onClick={AddressModalOpen}>
                        <Field
                            label="Select Business Address *"
                            type="text"
                            placeholder="Enter your Business Address"
                            name="address"
                            value={address?.street_address}
                            onChange={e => {
                                // setAddress(prev => ({
                                //     ...prev,
                                //     street_address: e.target.value,
                                // }));
                                handlePlaceSelect(e);
                            }}
                            parentClass="map-input-field"
                            $bgWhite
                        />
                    </div>
                    {/* </Autocomplete> */}
                    {searchValue && (
                        <>
                            <div className="signup-fields">
                                <Form.Item
                                    label="Unit / Suite Number (optional)"
                                    type="text"
                                    rounded
                                    name="suiteNumber"
                                    lg
                                    placeholder="e.g., Suite 202"
                                    $bgWhite>
                                    <Field />
                                </Form.Item>
                            </div>
                            <div className="signup-fields">
                                <Form.Item
                                    label="Province / Territory *"
                                    type="text"
                                    rounded
                                    name="province"
                                    lg
                                    placeholder="e.g., Alberta (AB)"
                                    $bgWhite
                                    rules={[
                                        {
                                            required: true,
                                            message: "Province / Territory is required",
                                        },
                                    ]}>
                                    <Field />
                                </Form.Item>
                            </div>
                            <div className="signup-fields">
                                <Form.Item
                                    label="City / Municipality *"
                                    type="text"
                                    rounded
                                    name="city"
                                    lg
                                    placeholder="e.g., Toronto"
                                    $bgWhite
                                    rules={[
                                        {
                                            required: true,
                                            message: "City / Municipality is required",
                                        },
                                    ]}>
                                    <Field />
                                </Form.Item>
                                <Form.Item
                                    label="Postal Code *"
                                    type="text"
                                    rounded
                                    name="postal_code"
                                    lg
                                    placeholder="e.g., M5A 1A1"
                                    $bgWhite
                                    rules={[
                                        {
                                            required: true,
                                            message: "Postal Code is required",
                                        },
                                    ]}>
                                    <Field />
                                </Form.Item>
                            </div>

                            <div className="signup-fields">
                                <Form.Item
                                    label="Area / Landmark (optional)"
                                    rounded
                                    name="area"
                                    lg
                                    placeholder="Add nearby landmark (optional)"
                                    $bgWhite>
                                    <Field />
                                </Form.Item>
                            </div>

                            <div className="btn-holder">
                                <Button lg disabled={currentStep === totalSteps}>
                                    Next
                                </Button>
                            </div>
                        </>
                    )}
                </Form>
            </BusinnesWrap>
        </>
    );
};

export default BusinessMap;
